<script setup lang="ts">
import { onLaunch } from '@dcloudio/uni-app'

onLaunch(() => {})
</script>

<style lang="scss">
@import "uview-pro/index.scss";
@import "common/style.scss";
</style>
